import roleLabel, { formatDate, formatDateTime } from '@/lib/utils'
import { IUserDetails } from '../_data/user-details-interface'

export default function UserDetailsInformation({
  data,
}: {
  data: IUserDetails
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-8 gap-6 text-charcoal">
      <div className="space-y-1 md:col-span-2">
        <p className="font-semibold">First Name</p>
        <p className="break-words">{data.firstName}</p>
      </div>
      <div className="space-y-1 md:col-span-2">
        <p className="font-semibold">Last Name</p>
        <p className="break-words">{data.lastName}</p>
      </div>
      <div className="space-y-1 md:col-span-4">
        <p className="font-semibold">Email</p>
        <p className="break-words">{data.email}</p>
      </div>
      <div className="space-y-1 md:col-span-2">
        <p className="font-semibold">Role</p>
        <p className="break-words">{roleLabel(data.role)}</p>
      </div>
      <div className="space-y-1 md:col-span-2">
        <p className="font-semibold">Joined Date</p>
        <p className="break-words">{formatDate(data.joinedDate)}</p>
      </div>
      <div className="space-y-1 md:col-span-4">
        <p className="font-semibold">Last Login</p>
        <p className="break-words">{formatDateTime(data.lastLogin)}</p>
      </div>
    </div>
  )
}
